export default __webpack_public_path__ + "static/media/shopify_connect-2-alt.cb36170f.svg";